import { KPIMetric } from './KPIMetric'
import { features } from '@/config/features'

export interface KPIData {
  visitors: number
  visitorsPrevious: number
  revenue: number
  revenuePrevious: number
  revenueConversionRate: number
  revenueConversionRatePrevious: number
  revenuePerVisitor: number
  revenuePerVisitorPrevious: number
  bounceRate: number
  bounceRatePrevious: number
  avgSessionDuration: number
  avgSessionDurationPrevious: number
  onlineCount: number
}

interface KPIRowProps {
  data: KPIData
  isLoading?: boolean
}

export function KPIRow({ data, isLoading }: KPIRowProps) {
  // When revenue features are disabled, show 4 KPIs instead of 7
  const kpiCount = features.revenue ? 7 : 4
  const gridCols = features.revenue
    ? 'grid-cols-2 md:grid-cols-4 lg:grid-cols-7'
    : 'grid-cols-2 md:grid-cols-4'

  if (isLoading) {
    return (
      <div className="section-card">
        <div className={`grid ${gridCols} divide-x divide-gray-100`}>
          {Array.from({ length: kpiCount }).map((_, i) => (
            <div key={i} className="kpi-card animate-pulse">
              <div className="w-6 h-6 bg-gray-200 rounded mb-2" />
              <div className="h-8 w-16 bg-gray-200 rounded mb-1" />
              <div className="h-3 w-12 bg-gray-100 rounded" />
            </div>
          ))}
        </div>
      </div>
    )
  }

  return (
    <div className="section-card">
      <div className={`grid ${gridCols} divide-x divide-gray-100`}>
        <KPIMetric
          icon="👥"
          label="Visitors"
          value={data.visitors}
          currentValue={data.visitors}
          previousValue={data.visitorsPrevious}
          format="number"
        />
        {features.revenue && (
          <>
            <KPIMetric
              icon="💰"
              label="Revenue"
              value={data.revenue}
              currentValue={data.revenue}
              previousValue={data.revenuePrevious}
              format="currency"
            />
            <KPIMetric
              icon="📈"
              label="Conversion"
              value={data.revenueConversionRate}
              currentValue={data.revenueConversionRate}
              previousValue={data.revenueConversionRatePrevious}
              format="percent"
            />
            <KPIMetric
              icon="💵"
              label="Rev/Visitor"
              value={data.revenuePerVisitor}
              currentValue={data.revenuePerVisitor}
              previousValue={data.revenuePerVisitorPrevious}
              format="currency"
            />
          </>
        )}
        <KPIMetric
          icon="🚪"
          label="Bounce Rate"
          value={data.bounceRate}
          currentValue={data.bounceRate}
          previousValue={data.bounceRatePrevious}
          format="percent"
          inverted // Lower is better
        />
        <KPIMetric
          icon="⏱️"
          label="Session Time"
          value={data.avgSessionDuration}
          currentValue={data.avgSessionDuration}
          previousValue={data.avgSessionDurationPrevious}
          format="duration"
        />
        <KPIMetric
          icon="🟢"
          label="Online"
          value={data.onlineCount}
          format="number"
          isLive
        />
      </div>
    </div>
  )
}
